<template>
    <a-row style="margin-top: 15vh">
        <a-col span="3"/>
        <a-col span="18">
            <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 8 }"
                          :wrapper-col=" { span: 16 }">
                <a-row>
                    <a-col span="12">
                        <a-form-model-item label="企业名称" prop="compyName">
                            <a-input class="input" v-model.trim="form.compyName" placeholder="请输入企业名称"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="12">
                        <a-form-model-item label="企业类型">
                            <a-input class="input" v-model.trim="form.compyType"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="12">
                        <a-form-model-item label="登记状态">
                            <a-input class="input" v-model.trim="form.registrationStatus"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="12">
                        <a-form-model-item label="登记机关">
                            <a-input class="input" v-model.trim="form.registrationAuthority"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="12">
                        <a-form-model-item label="法定代表人">
                            <a-input class="input" v-model.trim="form.legalRepresentative"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="12">
                        <a-form-model-item label="注册资本">
                            <a-input class="input" v-model.trim="form.registeredCapital"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="12">
                        <a-form-model-item label="成立日期">
                            <my-date class="input" :date-value.sync="form.establishmentDt"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="12">
                        <a-form-model-item label="核准日期">
                            <my-date class="input" :date-value.sync="form.approvalDt"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="12">
                        <a-form-model-item label="营业期限始">
                            <my-date class="input" :date-value.sync="form.businessTermStart"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="12">
                        <a-form-model-item label="营业期限止">
                            <my-date class="input" :date-value.sync="form.businessTermEnd"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="12">
                        <a-form-model-item label="经营范围">
                            <a-input class="input" v-model.trim="form.businessScope"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="12">
                        <a-form-model-item label="地址">
                            <a-input class="input" v-model.trim="form.address"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <div style="text-align: center;margin-top: 20px">
                <a-button type="primary" :loading="loading" @click="submit">
                    提交
                </a-button>
            </div>
        </a-col>
        <a-col span="3"/>
    </a-row>
</template>

<script>
    import {getComQueryList, comEditDetail} from './js/ApiSystem';
    import notification from 'ant-design-vue/es/notification'

    export default {
        data() {
            return {
                loading: false,
                notification,
                form: {},
                rules: {
                    compyName: [{required: true, message: '请输入企业名称', trigger: 'blur'},],
                },
            }
        },
        methods: {
            submit() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        comEditDetail(this.form).then(() => {
                            this.loading = false;
                            notification.success({
                                message: '修改成功!',
                            });
                        }).catch(() => {
                            this.loading = false;
                        })
                    }
                });

            }
        },
        created() {
            getComQueryList({}).then(res => {
                this.form = res.data.data[0];
            })
        }
    }
</script>

<style scoped>
.input{
    width: 300px
}
</style>
